module.exports = __webpack_public_path__ + "main/assets/public/masthead/close.b672f667b0677d99.svg";